import { render, staticRenderFns } from "./BoxForm.vue?vue&type=template&id=478bf574&"
import script from "./BoxForm.vue?vue&type=script&lang=js&"
export * from "./BoxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports